export default {
  shipping: {
    en: 'Shipping',
  },
  discount: {
    en: 'Discount',
  },
  total: {
    en: 'Total',
  },
  checkout: {
    en: 'Checkout',
  },
  shopNow: {
    en: 'Shop Now',
  },
  qualifiedFor: {
    en: 'You now qualify for',
  },
  standardShipping: {
    en: 'Free standard shipping',
  },
  addToQualify: {
    en: 'Add <span class="brandColor">{amount}</span> to your order to qualify',
  },
  freeShipping: {
    en: '<strong>Free Shipping:</strong> all products will be delivered with your subscription shipment.',
  },
}
